// extracted by mini-css-extract-plugin
export var indeterminate = "_5b-5";
export var md = "_5b-4";
export var semantic = "_5b-6";
export var sm = "_5b-3";
export var text = "_5b-7";
export var toggleInput = "_5b-0";
export var toggleSwitch = "_5b-1";
export var xs = "_5b-2";